import {animEndEventName, transEndEventName} from '@util/animation-prefixes';

const createEffect = eventType => ( el, className ) => {
    return new Promise( resolve => {
        if ( !el ) {
            resolve();
        }

        el.addEventListener( eventType, function cleanup () {
            el.classList.remove( className );
            el.removeEventListener( eventType, cleanup );
            resolve();
        } );

        el.classList.add( className );
    } );
};

/**
 * Trigger a css animation/transition by applying a className (removes class upon completion)
 * @example Effects.toggleAnimationFor( el, 'puff' ) );
 */
export const toggleAnimationFor = createEffect( animEndEventName );
export const toggleTransitionFor = createEffect( transEndEventName );
